import Vue from 'vue';
import _ from 'lodash';
import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import Util from 'src/utils/general';
import Project from 'src/api/project';
import { LOGOUT, FETCH_PROJECTS, TOGGLE_SHOW_ANNOUNCEMENTS } from 'src/store/types';
export default Vue.extend({
    components: { Multiselect },
    props: {
        expandBar: { type: Boolean, default: false }
    },
    data() {
        return {
            projectsList: [],
            search_string: '',
            isLoading: false
        };
    },
    computed: {
        ...mapGetters([
            'loggedIn', 'isSubscribed', 'isAdmin', 'userName', 'projects',
            'currentProject', 'currentUser', 'featureFlags', 'messages',
            'subscription'
        ]),
    },
    watch: {
        loggedIn() {
            if (this.loggedIn === true) {
                this.initDropDown();
            }
        },
        projects() {
            this.isLoading = false;
            this.$nextTick(() => {
                if (!this._evaluateSearch()) {
                    this.projectsList = this.projects;
                }
            });
        }
    },
    created() {
        this.isLoading = true;
        this.FETCH_PROJECTS().finally(() => { this.isLoading = false; });
    },
    mounted() {
        if (this.loggedIn === true) {
            this.initDropDown();
        }
    },
    methods: {
        ...mapActions({ FETCH_PROJECTS, TOGGLE_SHOW_ANNOUNCEMENTS }),
        // We need to pass vue multiselect a reference to a function. This is how we do that.
        // https://github.com/shentao/vue-multiselect/issues/127
        searchForProjectsHandler: _.debounce(function (search_string) {
            this.search_string = search_string;
            // Evaluate whether or not to display search results at dispatch and property set
            if (this._evaluateSearch()) {
                this.isLoading = true;
                Project.searchProjects(this.search_string)
                    .then((response) => {
                    if (this._evaluateSearch()) {
                        this.projectsList = response;
                    }
                    else {
                        this.projectsList = this.projects;
                    }
                    this.isLoading = false;
                })
                    .catch(() => {
                    this.isLoading = false;
                });
            }
            else {
                // If we don't send a search, the dropdown should be populated with initial project data
                this.projectsList = this.projects;
            }
        }, 300),
        truncProjectName(project) {
            return Util.truncateText(project.name);
        },
        goToProject(project) {
            if ((this.$route.name === 'project-details' && this.$route.params.projectId !== project.id) ||
                (this.$route.name !== 'project-details')) {
                this.$router.push({ name: 'project-details', params: { projectId: project.id } });
            }
        },
        doLogout() {
            $('#user-menu').dropdown('toggle');
            this.$store.dispatch(LOGOUT);
        },
        initDropDown() {
            this.$nextTick(() => {
                $('#user-menu').dropdown({
                    action: 'hide',
                    transition: 'drop'
                });
                $('#project-select').dropdown();
            });
        },
        _evaluateSearch() {
            return this.search_string !== '' && this.search_string !== null && this.search_string !== undefined;
        },
        showAnnouncements() {
            $('#user-menu').dropdown('toggle');
            this.TOGGLE_SHOW_ANNOUNCEMENTS();
        }
    },
});
